<div class="main-container">
  <div class="grid-container" id="926report-grid-container" style="height: calc(100vh - 124px);">
      <div class="top-toolbar">
          <div class="toolbar-actions">
            @if (taxyearLoaded) {
<ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)">
  @for (item of taxYearItems; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
}
            <gtw-df-me-dropdown class="top-filter-select me-dropdown-label" [customActionCode]="32136" (selectedMes)="selectedMeChanged($event)">
            </gtw-df-me-dropdown>
            <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" (onClick)="loadReport()"></ap-button>
            <span class="toolbar-export" (click)="exportToExcel()">
              <span class="Appkit4-icon icon-save-outline"></span>
              <span>Export to Excel</span>
            </span>
          </div>
      </div>

      <div class="dst-mat-grid-layout">
        @if (loading) {
          <div class="dst-mat-grid-loading">
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
        }
        <div class="dst-mat-grid">
          <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #matSort="matSort"
                 (matSortChange)="onMatSortChange()" class="dst-mat-table">

            <ng-container matColumnDef="STATEMENTID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[0])">{{ cols[0].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[0])">
                <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)"><span>{{ rowData.STATEMENTID }}</span></a>
              </td>
            </ng-container>

            <ng-container matColumnDef="PROJECT_NAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[1])">{{ cols[1].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[1])">
                <span>{{ rowData.PROJECT_NAME }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARYLEID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[2])">{{ cols[2].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[2])">
                <span>{{ rowData.PRIMARYLEID }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARYENTITY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[3])">{{ cols[3].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[3])">
                <span>{{ rowData.PRIMARYENTITY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARYBUSINESS">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[4])">{{ cols[4].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[4])">
                <span>{{ rowData.PRIMARYBUSINESS }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FILING_GROUP">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[5])">{{ cols[5].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[5])">
                <span>{{ rowData.FILING_GROUP }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="LINE1_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[6])">{{ cols[6].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[6])">
                <span>{{ rowData.LINE1_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="CHOICE2A_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[7])">{{ cols[7].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[7])">
                <span>{{ rowData.CHOICE2A_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="CHOICE2B_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[8])">{{ cols[8].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[8])">
                <span>{{ rowData.CHOICE2B_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SHOLDERNAME_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[9])">{{ cols[9].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[9])">
                <span>{{ rowData.SHOLDERNAME_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SHOLDEREIN_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[10])">{{ cols[10].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[10])">
                <span>{{ rowData.SHOLDEREIN_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="CHOICE2C_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[11])">{{ cols[11].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[11])">
                <span>{{ rowData.CHOICE2C_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PARENTCORP_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[12])">{{ cols[12].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[12])">
                <span>{{ rowData.PARENTCORP_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PARENTCORPEIN_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[13])">{{ cols[13].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[13])">
                <span>{{ rowData.PARENTCORPEIN_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="CHOICE2D_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[14])">{{ cols[14].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[14])">
                <span>{{ rowData.CHOICE2D_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="NAMEOFPARTNERSHIP_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[15])">{{ cols[15].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[15])">
                <span>{{ rowData.NAMEOFPARTNERSHIP_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="EINOFPARTNERSHIP_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[16])">{{ cols[16].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[16])">
                <span>{{ rowData.EINOFPARTNERSHIP_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="CHOICE3B_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[17])">{{ cols[17].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[17])">
                <span>{{ rowData.CHOICE3B_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="CHOICE3C_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[18])">{{ cols[18].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[18])">
                <span>{{ rowData.CHOICE3C_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="CHOICE3D_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[19])">{{ cols[19].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[19])">
                <span>{{ rowData.CHOICE3D_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="secondaryLeid">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[20])">{{ cols[20].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[20])">
                <span>{{ rowData.secondaryLeid }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SECONDARYENTITY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[21])">{{ cols[21].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[21])">
                <span>{{ rowData.SECONDARYENTITY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="ISFOREIGNCORPINGOLD_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[22])">{{ cols[22].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[22])">
                <span>{{ rowData.ISFOREIGNCORPINGOLD_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="ISTRANSFEREEFOREIGNCORPCTRLD_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[23])">{{ cols[23].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[23])">
                <span>{{ rowData.ISTRANSFEREEFOREIGNCORPCTRLD_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="DATEOFTRANSFER_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[24])">{{ cols[24].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[24])">
                <span gtwLineSplitter [inputString]="rowData.DATEOFTRANSFER_VAL" [sepearator]="'||'" [formatter]="'date'">
                  {{ rowData.DATEOFTRANSFER_VAL }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="TYPEOFPROPERTY_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[25])">{{ cols[25].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[25])">
                <span gtwLineSplitter [inputString]="rowData.TYPEOFPROPERTY_VAL" [sepearator]="'||'">
                  {{ rowData.TYPEOFPROPERTY_VAL }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FMVONDATEOFTRANSFER_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[26])">{{ cols[26].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[26])">
                <span gtwLineSplitter [inputString]="rowData.FMVONDATEOFTRANSFER_VAL" [sepearator]="'||'" [formatter]="'decimal'">
                  {{ rowData.FMVONDATEOFTRANSFER_VAL }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="COSTBASIS_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[27])">{{ cols[27].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[27])">
                <span gtwLineSplitter [inputString]="rowData.COSTBASIS_VAL" [sepearator]="'||'" [formatter]="'decimal'">
                  {{ rowData.COSTBASIS_VAL }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="GAINTRANSFER_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[28])">{{ cols[28].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[28])">
                <span gtwLineSplitter [inputString]="rowData.GAINTRANSFER_VAL" [sepearator]="'||'" [formatter]="'decimal'">
                  {{ rowData.GAINTRANSFER_VAL }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="USEFULLIFE_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[29])">{{ cols[29].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[29])">
                <span>{{ rowData.USEFULLIFE_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="INCOMEINCLUSIONOFTRANSFER_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[30])">{{ cols[30].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[30])">
                <span>{{ rowData.INCOMEINCLUSIONOFTRANSFER_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE11_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[31])">{{ cols[31].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[31])">
                <span>{{ rowData.F926LINE11_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE12A_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[32])">{{ cols[32].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[32])">
                <span>{{ rowData.F926LINE12A_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE12B_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[33])">{{ cols[33].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[33])">
                <span>{{ rowData.F926LINE12B_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE12C_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[34])">{{ cols[34].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[34])">
                <span>{{ rowData.F926LINE12C_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE12D_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[35])">{{ cols[35].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[35])">
                <span>{{ rowData.F926LINE12D_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE13_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[36])">{{ cols[36].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[36])">
                <span>{{ rowData.F926LINE13_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE14A_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[37])">{{ cols[37].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[37])">
                <span>{{ rowData.F926LINE14A_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE14B_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[38])">{{ cols[38].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[38])">
                <span>{{ rowData.F926LINE14B_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE14C_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[39])">{{ cols[39].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[39])">
                <span>{{ rowData.F926LINE14C_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE14D_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[40])">{{ cols[40].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[40])">
                <span>{{ rowData.F926LINE14D_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE15_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[41])">{{ cols[41].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[41])">
                <span>{{ rowData.F926LINE15_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SUPPLEMENTALINFO_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[42])">{{ cols[42].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[42])">
                <span>{{ rowData.SUPPLEMENTALINFO_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE16A_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[43])">{{ cols[43].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[43])">
                <span>{{ rowData.F926LINE16A_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE16B_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[44])">{{ cols[44].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[44])">
                <span>{{ rowData.F926LINE16B_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE17_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[45])">{{ cols[45].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[45])">
                <span>{{ rowData.F926LINE17_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE18A_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[46])">{{ cols[46].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[46])">
                <span>{{ rowData.F926LINE18A_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE18B_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[47])">{{ cols[47].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[47])">
                <span>{{ rowData.F926LINE18B_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE18C_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[48])">{{ cols[48].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[48])">
                <span>{{ rowData.F926LINE18C_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE18D_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[49])">{{ cols[49].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[49])">
                <span>{{ rowData.F926LINE18D_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE19_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[50])">{{ cols[50].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[50])">
                <span>{{ rowData.F926LINE19_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE20A_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[51])">{{ cols[51].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[51])">
                <span>{{ rowData.F926LINE20A_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE20B_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[52])">{{ cols[52].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[52])">
                <span>{{ rowData.F926LINE20B_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE20C_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[53])">{{ cols[53].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[53])">
                <span>{{ rowData.F926LINE20C_VAL }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="F926LINE21_VAL">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[54])">{{ cols[54].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[54])">
                <span>{{ rowData.F926LINE21_VAL }}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
          </table>
        </div>
      </div>
  </div>
</div>

@if (showModalViewer) {
<dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
</dst-disc-modal-viewer>
}
